module.exports = __webpack_public_path__ + "img/inicio.a7cc8459.svg";